import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 backdrop-blur-md transition-all duration-200 ${
        scrolled ? 'border-b border-white/[0.06] bg-[#080810]/90' : 'bg-transparent'
      }`}
    >
      <div className="mx-auto max-w-6xl px-6">
        <div className="flex h-16 items-center justify-between">
          {/* Wordmark */}
          <Link to="/" className="flex items-center gap-2 text-white">
            <span className="text-lg font-bold tracking-tight">CallPilot</span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            <a href="#features" className="text-sm text-zinc-400 hover:text-white transition-colors">Features</a>
            <a href="#use-cases" className="text-sm text-zinc-400 hover:text-white transition-colors">Use Cases</a>
            <a href="#pricing" className="text-sm text-zinc-400 hover:text-white transition-colors">Pricing</a>
            <a href="#faq" className="text-sm text-zinc-400 hover:text-white transition-colors">FAQ</a>
          </div>

          {/* Desktop CTAs */}
          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/login"
              className="text-sm text-zinc-300 hover:text-white transition-colors px-4 py-2 rounded-lg border border-transparent hover:border-white/10"
            >
              Sign In
            </Link>
            <Link
              to="/register"
              className="text-sm font-semibold bg-indigo-600 hover:bg-indigo-500 text-white px-4 py-2 rounded-lg transition-colors"
            >
              Start Free
            </Link>
          </div>

          {/* Mobile Hamburger */}
          <button
            className="md:hidden flex flex-col gap-1.5 p-2 text-zinc-300 hover:text-white transition-colors"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span className={`block w-5 h-0.5 bg-current transition-transform duration-200 ${menuOpen ? 'translate-y-2 rotate-45' : ''}`} />
            <span className={`block w-5 h-0.5 bg-current transition-opacity duration-200 ${menuOpen ? 'opacity-0' : ''}`} />
            <span className={`block w-5 h-0.5 bg-current transition-transform duration-200 ${menuOpen ? '-translate-y-2 -rotate-45' : ''}`} />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden border-t border-white/[0.06] bg-[#080810]/95 backdrop-blur-md px-6 py-4 flex flex-col gap-4">
          <a href="#features" className="text-sm text-zinc-300 hover:text-white transition-colors" onClick={() => setMenuOpen(false)}>Features</a>
          <a href="#use-cases" className="text-sm text-zinc-300 hover:text-white transition-colors" onClick={() => setMenuOpen(false)}>Use Cases</a>
          <a href="#pricing" className="text-sm text-zinc-300 hover:text-white transition-colors" onClick={() => setMenuOpen(false)}>Pricing</a>
          <a href="#faq" className="text-sm text-zinc-300 hover:text-white transition-colors" onClick={() => setMenuOpen(false)}>FAQ</a>
          <div className="flex flex-col gap-2 pt-2 border-t border-white/[0.06]">
            <Link to="/login" className="text-sm text-center py-2.5 px-4 rounded-lg border border-white/10 text-zinc-300 hover:text-white" onClick={() => setMenuOpen(false)}>Sign In</Link>
            <Link to="/register" className="text-sm font-semibold text-center py-2.5 px-4 rounded-lg bg-indigo-600 hover:bg-indigo-500 text-white transition-colors" onClick={() => setMenuOpen(false)}>Start Free</Link>
          </div>
        </div>
      )}
    </nav>
  );
}
